import { useQuery } from '@tanstack/react-query';
import { getTableRequest } from '@shared/utils';
import { getVehicles } from '@api/vehicles';

export const useVehicles = (search: string, pageSize: number = 5) => {
  const request = getTableRequest({
    pagination: {
      pageIndex: 0,
      pageSize,
    },
    search,
  });
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['vehicles', request],
    queryFn: () => getVehicles(request),
  });

  return {
    vehiclesOptions: data?.data ?? [],
    isVehiclesLoading: isLoading,
    isVehiclesFetching: isFetching,
  };
};
